import aggiungi from  './aggiungi'
import emettiFattura from './emetti-fattura'
import cambiaOfferta from './cambia-offerta'
import gestioneLetture from './gestione-letture'
import multipdrs from './multipdrs'
import multipdrsFile from './multipdrs-file'
import rcuUnico from './rcu-unico'
import sospensioni from './sospensioni'
import riattivazioni from './riattivazioni'
import daSospendere from './da-sospendere'
import daRiattivare from './da-riattivare'
import aggiungiVociFatturaMassivo from './aggiungi-voci-fattura-massivo'
import caricaConsumiFile from './carica-consumi-file'
import caricaLettureFile from './carica-letture-file'
import sospensioniSaldate from './sospensioni-saldate'
import rilascioTutela from './rilascioTutela'

export default [
  // always
  {
    'key': 'pdrs-button-aggiungi',
    'label': 'AGGIUNGI FORNITURA',
    'classCss': 'p-button-secondary',
    'icon': 'pi pi-plus',
    'type': 'operation',
    'method': aggiungi,
    'display': 'always'
  },
  {
    'key': 'pdrs-multipdr-file',
    'label': 'MULTIPDRS FILE',
    'classCss': 'p-button-secondary',
    'icon': ' pi pi-file',
    'type': 'operation',
    'method': multipdrsFile,
    'display': 'always'
  },
  {
    'key': 'pdrs-rcu-unico',
    'label': 'RCU UNICO',
    'classCss': 'p-button-secondary',
    'icon': ' pi pi-book',
    'type': 'operation',
    'method': rcuUnico,
    'display': 'always'
  },
  {
    'key': 'pdrs-aggiungi-voci-fattura-massivo',
    'label': 'AGGIUNGI VOCI FATTURA MASSIVO',
    'classCss': 'p-button-secondary',
    'icon': 'pi pi-plus',
    'type': 'operation',
    'method': aggiungiVociFatturaMassivo,
    'display': 'always'
  },
  {
    'key': 'pdrs-carica-consumi-file',
    'label': 'CARICA CONSUMI FILE',
    'classCss': 'p-button-secondary',
    'icon': 'pi pi-arrow-circle-up',
    'type': 'operation',
    'method': caricaConsumiFile,
    'display': 'always'
  },
  {
    'key': 'pdrs-carica-letture-file',
    'label': 'CARICA LETTURE FILE',
    'classCss': 'p-button-secondary',
    'icon': 'pi pi-arrow-circle-up',
    'type': 'operation',
    'method': caricaLettureFile,
    'display': 'always'
  },
  {
    'key': 'pdrs-sospensioni-saldate',
    'label': 'SOSPENSIONI SALDATE',
    'classCss': 'p-button-secondary',
    'icon': ' pi pi-check',
    'type': 'operation',
    'method': sospensioniSaldate,
    'display': 'always'
  },
  // on-data-filtered
  {
    'key': 'pdrs-button-emetti-fattura',
    'label': 'EMETTI FATTURA',
    'classCss': 'p-button-secondary',
    'icon': ' pi pi-directions',
    'type': 'operation',
    'method': emettiFattura,
    'display': 'on-data-filtered'
  },
  {
    'key': 'pods-button-gestione-lettura',
    'label': 'GESTIONE LETTURE',
    'classCss': 'p-button-secondary',
    'icon': ' pi pi-directions',
    'type': 'operation',
    'method': gestioneLetture,
    'display': 'on-data-filtered'
  },
  {
    'key': 'pdrs-button-cambia-offerta',
    'label': 'CAMBIA OFFERTA',
    'classCss': 'p-button-secondary',
    'icon': ' pi pi-directions',
    'type': 'operation',
    'method': cambiaOfferta,
    'display': 'on-data-filtered'
  },
  {
    'key': 'pdrs-multipdr',
    'label': 'MULTIPDRS',
    'classCss': 'p-button-warning',
    'icon': ' pi pi-download',
    'type': 'operation',
    'method': multipdrs,
    'display': 'on-data-filtered'
  },
  {
    'key': 'pdrs-sospensioni',
    'label': 'SOSPENDI',
    'classCss': 'p-button-warning',
    'icon': ' pi pi-pause',
    'type': 'operation',
    'method': sospensioni,
    'display': 'on-data-filtered'
  },
  {
    'key': 'pdrs-riattivazioni',
    'label': 'RIATTIVA',
    'classCss': 'p-button-primary',
    'icon': ' pi pi-play',
    'type': 'operation',
    'method': riattivazioni,
    'display': 'on-data-filtered'
  },
  {
    'key': 'pdrs-da-sospendere',
    'label': 'DA SOSPENDERE',
    'classCss': 'p-button-warning',
    'icon': ' far fa-pause-circle',
    'type': 'operation',
    'method': daSospendere,
    'display': 'on-data-filtered'
  },
  {
    'key': 'pdrs-da-riattivare',
    'label': 'DA RIATTIVARE',
    'classCss': 'p-button-primary',
    'icon': ' far fa-play-circle',
    'type': 'operation',
    'method': daRiattivare,
    'display': 'on-data-filtered'
  },
  {
    'key': "pdrs-rilascio-tutela",
    'label': "RILASCIO TUTELA",
    'classCss': "p-button-danger",
    'icon': " far fa-pause-circle",
    'type': "operation",
    'method': rilascioTutela,
    'display': "on-data-filtered",
  },
]
